import Vue from 'vue'
import Vuex from 'vuex'

import access from './modules/access'
import cargoflow from './modules/cargoflow'
import vesselpath from './modules/vesselpath'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    access: {
      namespaced: true,
      ...access
    },
    cargoflow: {
      namespaced: true,
      ...cargoflow
    },
    vesselpath:{
      namespaced: true,
      ...vesselpath
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js